/**
 * @desc 分页
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.esca.EChapterRequestParamsDto,
  params: API.esca.eChapter.page.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/eChapter/page`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
